<template>
  <nav> 
    <div class="flex flex-col">
        <NavigationItemGallery class="pl-24 my-12"/>
        <NavigationItemClients class="pl-24 mb-12"/>
        <NavigationItemStats class="pl-24 mb-12"/>
        <NavigationItemSettings class="pl-24 mt-34"/>
    </div>
  </nav>

      <!-- <a href="#responsive-header" class="block mt-4 lg:inline-block lg:mt-0 text-teal-lighter hover:text-white mr-4">
        Clients
      </a>
      <a href="#responsive-header" class="block mt-4 lg:inline-block lg:mt-0 text-teal-lighter hover:text-white">
        Bookings
      </a>
      <a href="#responsive-header" class="block mt-4 lg:inline-block lg:mt-0 text-teal-lighter hover:text-white">
        Settings
      </a> -->
</template>

<script>
import NavigationItemGallery from './navigation/NavigationItemGallery';
import NavigationItemClients from './navigation/NavigationItemClients';
import NavigationItemStats from './navigation/NavigationItemStats';
import NavigationItemSettings from './navigation/NavigationItemSettings';

export default {
  name:'Navigation',
  components: {
		NavigationItemGallery,
		NavigationItemClients,
		NavigationItemStats,
		NavigationItemStats,
		NavigationItemSettings,
  },
  
  methods: {
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Navigation.vue